module.exports = __webpack_public_path__ + "img/pass.b7a15ce4.png";